/**
 * VIP Buyout form logic - vipVykup.latte
 */
$(document).ready(function () {

    if ($('#frm-vipOfferForm-znacka').length === 0) return;

    // --- Původ vozidla ---

    $('input[name="origin_import"]').on('change', function () {
        if ($(this).is(':checked')) {
            $('#origin_country_wrapper').addClass('d-flex');
            $('input[name="origin_cz"]').prop('checked', false);
        } else {
            $('#origin_country_wrapper').removeClass('d-flex');
        }
    });

    $('input[name="origin_cz"]').on('change', function () {
        if ($(this).is(':checked')) {
            $('input[name="origin_import"]').prop('checked', false).trigger('change');
        }
    });

    // --- Poškození ---

    $('input[name="damaged"]').on('change', function () {
        if ($(this).is(':checked')) {
            $('#crashed_how_wrapper').show();
        } else {
            $('#crashed_how_wrapper').hide();
        }
    });

    // Inicializace stavů checkboxů
    $('input[name="origin_import"], input[name="damaged"]').trigger('change');

    // --- Drag & Drop upload ---

    new FileDropZone({
        dropZone:  '#drop-zone',
        fileInput: '#photos-input',
        fileList:  '#file-list'
    });

});
